import { refreshCellElement, rowFillHandler, getTextSpace } from '../../workbook/common/event';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { getTextWidth, getExcludedColumnWidth } from '../common/index';
/**
 * Specifies number format.
 */
export class NumberFormat {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
        //Spreadsheet.Inject(WorkbookNumberFormat);
    }
    refreshCellElement(args) {
        const cell = args.cellEle || this.parent.getCell(args.rowIndex, args.colIndex);
        if (!isNullOrUndefined(cell)) {
            this.parent.refreshNode(cell, args);
        }
    }
    getTextSpace(args) {
        args.width = getTextWidth(args.char, args.cell.style, this.parent.cellStyle);
    }
    rowFillHandler(args) {
        const cellElem = args.cellEle || this.parent.getCell(args.rowIdx, args.colIdx);
        if (cellElem) {
            const repeatCharWidth = getTextWidth(args.repeatChar, args.cell.style, this.parent.cellStyle);
            let cellWidth = getExcludedColumnWidth(this.parent.getActiveSheet(), args.rowIdx, args.colIdx);
            if (args.beforeFillText) {
                cellElem.innerHTML = args.beforeFillText;
                cellWidth -= getTextWidth(args.beforeFillText, args.cell.style, this.parent.cellStyle);
            }
            else {
                cellElem.innerHTML = '';
            }
            const repeatCharSpan = this.parent.createElement('span', { className: 'e-fill' });
            cellElem.appendChild(repeatCharSpan);
            if (args.afterFillText) {
                const textSpan = this.parent.createElement('span', { className: 'e-fill-sec', innerHTML: args.afterFillText });
                cellElem.appendChild(textSpan);
                cellWidth -= getTextWidth(args.afterFillText, args.cell.style, this.parent.cellStyle);
            }
            const repeatCount = parseInt((cellWidth / repeatCharWidth).toString(), 10);
            args.formattedText = repeatCount > 0 ? args.repeatChar.repeat(repeatCount) : '';
            repeatCharSpan.textContent = args.formattedText;
        }
    }
    /**
     * Adding event listener for number format.
     *
     * @hidden
     * @returns {void} - Adding event listener for number format.
     */
    addEventListener() {
        this.parent.on(refreshCellElement, this.refreshCellElement, this);
        this.parent.on(rowFillHandler, this.rowFillHandler, this);
        this.parent.on(getTextSpace, this.getTextSpace, this);
    }
    /**
     * Removing event listener for number format.
     *
     * @hidden
     * @returns {void} - Removing event listener for number format.
     */
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(refreshCellElement, this.refreshCellElement);
            this.parent.off(rowFillHandler, this.rowFillHandler);
            this.parent.off(getTextSpace, this.getTextSpace);
        }
    }
    /**
     * To Remove the event listeners.
     *
     * @returns {void} - To Remove the event listeners.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    /**
     * Get the workbook import module name.
     *
     * @returns {string} - Get the workbook import module name.
     */
    getModuleName() {
        return 'numberFormat';
    }
}
